// EPIC-P05-07: Badge Preview Component
// Live preview of badge with current form values

import { BadgeImage } from '@/components/profile/BadgeImage'
import { AdminCard } from '../primitives'
import { Badge } from '@/components/ui/badge'

interface BadgePreviewProps {
  category: 'analysis' | 'practice' | 'streak' | 'milestone' | 'social'
  rarity: 'common' | 'rare' | 'epic' | 'legendary'
  title?: string
  description?: string
  badge_key?: string
  icon_path?: string | null
}

export function BadgePreview({ category, rarity, title, description, badge_key, icon_path }: BadgePreviewProps) {
  return (
    <AdminCard accentColor="info" title="Preview">
      <div className="space-y-4">
        {/* Badge Image */}
        <div className="flex justify-center">
          <BadgeImage
            category={category}
            rarity={rarity}
            badge_key={badge_key}
            image_path={icon_path}
            size={128}
          />
        </div>

        {/* Badge Info */}
        <div className="space-y-2 text-center">
          {title ? (
            <h3 className="text-lg font-semibold">{title}</h3>
          ) : (
            <h3 className="text-lg font-semibold text-muted-foreground">Badge Title</h3>
          )}
          
          {description ? (
            <p className="text-sm text-muted-foreground">{description}</p>
          ) : (
            <p className="text-sm text-muted-foreground italic">Badge description will appear here</p>
          )}

          <div className="flex items-center justify-center gap-2 pt-2">
            <Badge variant="outline">{category}</Badge>
            <Badge>{rarity}</Badge>
          </div>
        </div>
      </div>
    </AdminCard>
  )
}

